import authenticate from '@/services/authenticate'

export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "app-dashboard" */ '@/views/app'),
    beforeEnter: authenticate,
    redirect: '/app/dashboards/home',

    // Dashboards
    children: [
      {
        path: '/app/dashboards',
        component: () => import(/* webpackChunkName: "dashboards" */ '@/views/app/dashboards'),
        children: [
          {
            path: 'home',
            // component: () => import(/* webpackChunkName: "dashboard-v1" */ '@/views/app/dashboards/home')
            component: () => import(/* webpackChunkName: "grafico-lucratividade-home" */ '@/views/app/relatorios/graficoLucratividade')
          }
        ]
      },
      // RELATORIOS E GRAFICOS
      {
        path: '/app/relatorios',
        component: () => import(/* webpackChunkName: "sessions" */ '@/views/app/relatorios'),
        redirect: '/app/relatorios/grafico-lucratividade',
        children: [
          {
            path: 'grafico-lucratividade',
            component: () => import(/* webpackChunkName: "grafico-lucratividade" */ '@/views/app/relatorios/graficoLucratividade')
          },
          {
            path: 'grafico-rentabilidade',
            component: () => import(/* webpackChunkName: "grafico-rentabilidade" */ '@/views/app/relatorios/graficoRentabilidade')
          },
          {
            path: 'tabela-lucratividade',
            component: () => import(/* webpackChunkName: "tabela-lucratividade" */ '@/views/app/relatorios/tabelaLucratividade')
          }
        ]
      }
    ]
  },
  {
    path: '/app/sessions',
    component: () => import(/* webpackChunkName: "sessions" */ '@/views/app/sessions'),
    redirect: '/app/sessions/signIn',
    children: [
      {
        path: 'signIn',
        component: () => import(/* webpackChunkName: "signIn" */ '@/views/app/sessions/signIn')
      },
      // {
      //   path: 'signUp',
      //   component: () => import(/* webpackChunkName: "signUp" */ '@/views/app/sessions/signUp')
      // },
      // {
      //   path: 'forgot',
      //   component: () => import(/* webpackChunkName: "forgot" */ '@/views/app/sessions/forgot')
      // },
      {
        path: 'device',
        component: () => import(/* webpackChunkName: "device" */ '@/views/app/sessions/device')
      }
    ]
  }
  // Not Found
  // {
  //   path: '*',
  //   component: () => import(/* webpackChunkName: "notfound" */ '@/views/app/pages/notFound')
  // }
]
